<template>
  <div>
      <h3 class="mb-0">Solicitor Details</h3>
      <b-form role="form" class="mt-4" @submit.prevent="addSolicitor">
          <b-row>
              <!-- <b-col md="8" cols="12">
                  <b-form-group label="Insurance Type">
                      <b-form-radio-group
                          required
                          v-model="form.product_type"
                          :options="productOptions"
                      ></b-form-radio-group>
                  </b-form-group>
              </b-col>
              
              <b-col md="8" cols="12">
                  <b-form-group label="Package">
                      <el-select v-model="form.package_name" placeholder="Select">
                          <el-option
                              v-for="(item, index) in packageOptions"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                          ></el-option>
                      </el-select>
                  </b-form-group>
              </b-col>
              
              <b-col md="8" cols="12">
                  <b-form-group label="Company">
                      <el-select v-model="form.company_name" placeholder="Select">
                          <el-option
                              v-for="(item, index) in companyOptions"
                              :key="index"
                              :label="item.label"
                              :value="item.value"
                          ></el-option>
                      </el-select>
                  </b-form-group>
              </b-col> -->

              <b-col md="8" cols="12">
                <b-form-group label="Product">
                  <el-select v-model="form.product_type" placeholder="Select">
                    <el-option
                      v-for="(item, index) in productTypes"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </b-form-group>
              </b-col>

              <b-col md="8" cols="12">
                  <b-form-group label="SPA Amount (RM)">
                      <CurrencyInput
                          v-model="form.spa_amount"
                          :options="{ currency: 'MYR', currencyDisplay: 'hidden', autoDecimalDigits: true }"
                      />
                  </b-form-group>
              </b-col>

              <b-col md="8" cols="12" v-if="form.product_type === 'Loan Agreement'">
                  <b-form-group label="Loan Margin (%)">
                      <CurrencyInput
                          v-model="form.loan_margin"
                          :options="{ currency: 'MYR', currencyDisplay: 'hidden',}"
                      />
                  </b-form-group>
              </b-col>

              <!-- Bank Selection -->
              <b-col md="8" cols="12" v-if="form.product_type === 'Loan Agreement'">
                  <b-form-group label="Select Bank">
                    <el-select v-model="form.bank_name" placeholder="Select Bank" :loading="is_loading_bank">
                      <el-option
                        v-for="(bank, index) in banks"
                        :key="index"
                        :label="bank.name"
                        :value="bank.name"
                      ></el-option>
                    </el-select>
                  </b-form-group>
                </b-col>

              <b-col md="8" cols="12">
                  <b-form-group label="Title Type">
                      <b-form-radio-group
                          required
                          v-model="form.title_type"
                          :options="typeOptions"
                      ></b-form-radio-group>
                  </b-form-group>
              </b-col>

              <b-col md="8" cols="12">
                  <b-form-group label="Land Type">
                      <b-form-radio-group
                          required
                          v-model="form.land_type"
                          :options="landOptions"
                      ></b-form-radio-group>
                  </b-form-group>
              </b-col>

              <b-col md="8" cols="12">
                <b-form-group label="Property Type">
                  <el-select v-model="form.property_type" placeholder="Select">
                    <el-option
                      v-for="(item, index) in propertyType"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </b-form-group>
              </b-col>

              <b-col md="8" cols="12">
                  <b-form-group label="Malay Reserve Land">
                      <b-form-radio-group
                          required
                          v-model="form.malay_reserve"
                          :options="booleanOptions"
                      ></b-form-radio-group>
                  </b-form-group>
              </b-col>

              <b-col md="8" cols="12">
                  <b-form-group label="Joint Name">
                      <b-form-radio-group
                          required
                          v-model="form.joint_name"
                          :options="booleanOptions"
                      ></b-form-radio-group>
                  </b-form-group>
              </b-col>

              <b-col md="8" cols="12">
                  <b-form-group label="if select Yes Joint Name, please select the number of Joint Name ">
                      <b-form-input
                          v-model="form.joint_name_no"
                          type="number"
                          min="1"
                          placeholder="Enter number of joint names"
                      />
                  </b-form-group>
              </b-col>

              <b-col md="8" cols="12">
                  <b-form-group label="First Home">
                      <b-form-radio-group
                          required
                          v-model="form.first_home"
                          :options="booleanOptions"
                      ></b-form-radio-group>
                  </b-form-group>
              </b-col>
                    <!-- Product Type Dropdown -->
                    <b-col cols="12" md="8" v-if="form.product_type === 'Loan Agreement'">
                            <b-form-group label="Product Type Subject" >
                              <b-form-radio-group
                                v-model="form.product_subject" 
                                :options="prodSubTypeOptions">
                              </b-form-radio-group>
                            </b-form-group>
                          </b-col>
                          <!-- Loan Type Dropdown -->
                          <b-col cols="12" md="6"  v-if="form.product_type === 'Loan Agreement'">
                              <b-form-group label="Loan Type">
                                  <b-form-radio-group v-model="form.loan_type" :options="loanTypeOptions"></b-form-radio-group>
                              </b-form-group>
                          </b-col>
              <b-col md="8" cols="12">
                  <b-button block variant="primary" @click="showQuotationModal"  class="mb-5">Generate Quotation</b-button>
                  <!-- <b-button block variant="primary" class="mb-5" type="submit">Add</b-button> -->
              </b-col>
          </b-row>
      </b-form>
    <!-- Modal for solicitor selection and form submission -->
    <modal
      ref="quotationModal"
      :show="isModalVisible"
      title="Generate Quotation"
      @close="hideQuotationModal"
    >
      <b-form @submit.prevent="submitQuotation" :style="{ width: '800px', maxWidth: '90%' }" >
              <!-- Loading overlay -->
        <div v-if="isLoading" class="loading-overlay">
          <b-spinner label="Loading..." variant="primary"></b-spinner>
        </div>
        <b-form-group label="Select Solicitor">
          <el-select v-model="selectedSolicitor" placeholder="Select Solicitor">
            <el-option
            v-for="(solicitor, index) in solicitorList"
              :key="index"
              :label="solicitor.text"
              :value="solicitor"
            ></el-option>
          </el-select>
        </b-form-group>

        <!-- Add more fields in the modal if needed -->

        <b-button :disabled="isLoading" type="submit" variant="success">
        <span v-if="isLoading">
          <b-spinner small label="Submitting..."></b-spinner> Submitting...
        </span>
        <span v-else>Submit</span>
      </b-button>
      </b-form>
    </modal>
  </div>
</template>
<script>
import { Select, Option, RadioGroup, RadioButton } from 'element-ui'
import solutionEventBus from '@/assets/js/EventBus/solutionEventBus.js'
import CurrencyInput from '@/components/CurrencyInput'
import { axios, services, getHeader, notifyFunctionMixin, helperFunctionMixin } from '@/assets/js/httpImports.js'
import { mapActions } from 'pinia'
import { useProductStore } from '@/stores/productStore'
import { useLookupStore } from '@/stores/lookupStore'
import { useHestiaStore } from '@/stores/hestiaStore'
export default {
  mixins:[
      notifyFunctionMixin,
  ],
  components: {
      CurrencyInput,
      [Select.name]: Select,
      [Option.name]: Option,
      [RadioGroup.name]: RadioGroup,
      [RadioButton.name]: RadioButton,
  },
  data() {
      return {
        isLoading: false,
          form: {
              product_type: '',
              spa_amount: 0,
              title_type: '',
              land_type: '',
              property_type: '',
              malay_reserve: '',
              joint_name: '',
              joint_name_count: 0,
              first_home: '',
              loan_margin: '90',     
              bank_name: ''  ,
              product_subject: '',
              loan_type:'',
          },
          banks: [],               
          is_loading_bank: false,
          selectedSolicitor:'',
          propertyType: [], 
          solicitorList: [],
          isModalVisible: false,
          typeOptions: [
              { text: 'Master', value: 'Master' },
              { text: 'Individual', value: 'Individual' },
              { text: 'Starta', value: 'Starta' }
          ],
          landOptions: [
              { text: 'Freehold', value: 'Freehold' },
              { text: 'Leasehold', value: 'Leasehold' }
          ],
         booleanOptions: [
              { text: 'Yes', value: '1' },
              { text: 'No', value: '0' }
          ],
          productTypes: [],
          loanTypeOptions: [
            { text: 'Islamic', value: 'islamic' },
            { text: 'Conventional', value: 'conventional' }
          ],
          prodSubTypeOptions: [
            { text: 'Refinance', value: 'refinance' },
            { text: 'Subsale', value: 'subsale' },
            { text: 'Auction', value: 'auction' },
            { text: 'Mortgage', value: 'mortgage' },
            { text: 'Property', value: 'property' },
          ],
      }
  },
  created() {
      this.fetchPropertyTypes();
      this.fetchBankList();
      this.getProduct();
      this.getSolicitors();
      // this.getSolicitor();
  },
  methods: {
      ...mapActions(useProductStore, ['createSolicitorProduct']),
      ...mapActions(useLookupStore, ['getPropertyTypes','getLookupTables','getFeesCharges']),
      ...mapActions(useHestiaStore, ['getHestiaSolicitor']),
      async fetchPropertyTypes() {
          try {
              const response = await this.getPropertyTypes();
              const types = response.data; // Assuming the data is directly under 'data'
              const sortedTypes = types.sort((a, b) => a.name.localeCompare(b.name));
              this.propertyType = sortedTypes.map(type => ({
                  label: type.name,  // Assuming 'name' is the label
                  value: type.prpty_type_id // Assuming 'prpty_type_id' is the value
              }));
          } catch (error) {
            console.error(error);  // Add this to log the actual error
              this.errorFunction(null, 'Failed to load property types');
          }
      },
      async fetchBankList() {
          try {
            const res = await this.getLookupTables(['banks'])
            // const banks = res.banks
            this.banks =  res.banks
          } catch (error) {
            console.error(error);  // Add this to log the actual error
              this.errorFunction(null, 'Failed to load banks');
          }
      },
      async getProduct() {
        try {
          const data = await this.getFeesCharges(); // Wait for the data from getSpaStatus
          const uniqueProducts = [...new Set(data.map(item => item.product))];
    
          // Map the unique products to a format suitable for el-select options
          this.productTypes = uniqueProducts.map(product => ({
            label: product,
            value: product,
          }));
        } catch (err) {
          console.error("Error in getStatus:", err);
        } 
      },
      async getSolicitors() {
      try {
        const res = await axios.get(services.access_control + 'corporate', {
          headers: getHeader(),
          params: {
            corporate_type: 'SOLICITOR'
          }
        });
        // Map response data to use corporate_name and corporate_id
        this.solicitorList = res.data.data.map(solicitor => ({
          text: solicitor.name,
          value: solicitor.id, 
          name: solicitor.name 
        }));
        } catch (e) {
        this.solicitorList = [];
        console.log('Get corporates failed:', e.response?.data?.message || e.message);
      }
    },
      resetForm(){
          this.form.product_type = '',
          this.form.spa_amount = 0,
          this.form.title_type = '',
          this.form.land_type = '',
          this.form.property_type = '',
          this.form.malay_reserve = '',
          this.form.joint_name = '',
          this.form.joint_name_no = '',
          this.form.first_home = '',
          this.form.loan_margin = '90';
          this.form.bank_name = ''; 
          this.form.product_subject = '';
          this.form.loan_type = '';
      },
      showQuotationModal() {
        this.isModalVisible = true;  // Show the modal
      },
      hideQuotationModal() {
        this.isModalVisible = false;  // Hide the modal
      },
      async submitQuotation() {
        this.isLoading = true
        if (!this.selectedSolicitor) {
          this.errorFunction(null, 'Please select a solicitor.')
          this.isLoading = false;
          return
        }
        const solicitor = {
            prod_sol_type: this.form.product_type,
            prod_sol_spa_amount:this.form.spa_amount,
            prod_sol_loan_margin: this.form.loan_margin, 
            prod_sol_bnk_name: this.form.bank_name,   
            prod_sol_title_type:this.form.title_type,
            prod_sol_land_type:this.form.land_type,
            prod_sol_property_type:this.form.property_type,
            prod_sol_malay_reserve:this.form.malay_reserve,
            prod_sol_joint_name:this.form.joint_name,
            prod_sol_joint_no:this.form.joint_name_no,
            prod_sol_first_home:this.form.first_home,
            prod_sol_firm:this.selectedSolicitor.name,
            prod_sol_firm_id: this.selectedSolicitor.value,
            prod_sol_loan_type:this.form.loan_type,
            prod_sol_prod_type_subject:this.form.product_subject,
        }
        useProductStore().$patch((state) => {
            state.current_product_data = { 
                ...state.current_product_data, 
                solicitor: solicitor
            }
        })
        try {
          await this.createSolicitorProduct()
          this.notifySuccess('Quotation successfully generated!')
          this.hideQuotationModal();
          this.resetForm()
          solutionEventBus.$emit('show-solicitor-summary')
        } catch (error) {
          this.errorFunction(null, 'Failed to generate quotation.')
        }finally {
          this.isLoading = false; // Reset loading state at the end
        }
      },
      preventNonNumericInput(event) {
          const keyCode = event.keyCode || event.which;
          const keyValue = String.fromCharCode(keyCode);
          const currencyRegex = /^[\d.,$]+(\.[\d.,$]+)?$/;
          const allowedKeys = [8, 37, 38, 39, 40, 46];
          if (keyCode !== 190 && !currencyRegex.test(keyValue) && !allowedKeys.includes(keyCode)) {
              event.preventDefault();
          }
      },
      emitEvent(eventName) {
          solutionEventBus.$emit(eventName)
      },
  }
}
</script>